import { api } from 'utils/apis/api';
export const uploadsApi = api
    .enhanceEndpoints({
    addTagTypes: ['Announcement'],
})
    .injectEndpoints({
    endpoints: (builder) => ({
        createPresignedUrls: builder.mutation({
            query: ({ type, file, name }) => ({
                version: 1,
                method: 'POST',
                path: `uploads/presigned_url/${type}`,
                body: {
                    pretty_name: name || file.name,
                    content_type: file.type,
                },
            }),
        }),
        readAnnouncements: builder.query({
            query: () => ({
                version: 1,
                path: 'uploads/announcement',
            }),
            providesTags: (result) => {
                const { uploads = [] } = (result === null || result === void 0 ? void 0 : result.data) || {};
                return uploads.map(({ url }) => {
                    const [_, id] = url.match(/.+\/(.+\..{2,5})$/) || []; // get file name from url
                    return { type: 'Announcement', id };
                });
            },
        }),
        deleteAnnouncement: builder.mutation({
            query: ({ file }) => ({
                version: 1,
                path: `uploads/announcement/${file}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result) => [
                { type: 'Announcement', id: result === null || result === void 0 ? void 0 : result.data.delete_file },
            ],
        }),
    }),
});
